module.exports = __webpack_public_path__ + "img/gjxs.b9961c45.png";